import * as Yup from 'yup';

export const AssignGradeSchema = Yup.object().shape({
  approval_reason_id: Yup.number().required('Seleccione un motivo de aprobación.').nullable(),
});
